import React from "react";
import "./LoadingAnimation.css";

const LoadingAnimation = () => {
  return (
    <div
      className="admin-loader-overlay"
      role="status"
      aria-live="polite"
      aria-label="Loading"
    >
      <div className="admin-loader-progress-track" aria-hidden="true">
        <div className="admin-loader-progress-bar" />
      </div>

      <div className="admin-loader-core" aria-hidden="true">
        <div className="admin-loader-ring">
          <span className="admin-loader-ring-glow" />
        </div>
        <div className="admin-loader-dots">
          <span />
          <span />
          <span />
        </div>
      </div>
    </div>
  );
};

export default LoadingAnimation;
